module.exports = __webpack_public_path__ + "fonts/boxicons.afbad0fa.eot";